import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import { RequireAuth } from "@/auth/RequireAuth";
import { RequireSection } from "@/auth/RequireSection";
import { Shell } from "@/components/Shell";
import { LoginPage } from "@/pages/LoginPage";
import { HomePage } from "@/pages/HomePage";
import { IngestorPage } from "@/pages/IngestorPage";
import { ProductsPage } from "@/pages/ProductsPage";
import { MovedToFlow } from "@/pages/MovedToFlow";
import { WorkflowPage } from "@/pages/WorkflowPage";
import { WebsitePage } from "@/pages/WebsitePage";
import { MarketingPage } from "@/pages/marketing/MarketingPage";
import { FinancePage } from "@/pages/FinancePage";
import { OpenItemsPage } from "@/pages/finance/OpenItemsPage";
import { LiveNumbersPage } from "@/pages/finance/LiveNumbersPage";
import { HealthPage } from "@/pages/finance/HealthPage";

export function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route
        element={
          <RequireAuth>
            <Shell />
          </RequireAuth>
        }
      >
        <Route index element={<RequireSection section="home"><HomePage /></RequireSection>} />
        <Route path="/products" element={<RequireSection section="products"><ProductsPage /></RequireSection>} />
        <Route path="/studio" element={<RequireSection section="studio"><IngestorPage /></RequireSection>} />
        {/* Old links (bookmarks) keep working: /ingestor?tab=… → /studio?tab=… */}
        <Route path="/ingestor" element={<IngestorRedirect />} />
        {/* Website orders moved to Flow → Sales (CEO 2026-10-12): old links and the
            alert emails sent before the move forward there, keeping ?order= / ?request=. */}
        <Route path="/website-orders" element={<MovedToFlow path="/sales/website-orders" />} />
        <Route path="/workflow" element={<RequireSection section="workflow"><WorkflowPage /></RequireSection>} />
        <Route path="/website" element={<RequireSection section="website"><WebsitePage /></RequireSection>} />
        <Route path="/marketing/*" element={<RequireSection section="marketing"><MarketingPage /></RequireSection>} />
        <Route path="/finance" element={<RequireSection section="finance"><FinancePage /></RequireSection>} />
        <Route path="/finance/open-items" element={<RequireSection section="finance"><OpenItemsPage /></RequireSection>} />
        <Route path="/finance/numbers" element={<RequireSection section="finance"><LiveNumbersPage /></RequireSection>} />
        <Route path="/finance/health" element={<RequireSection section="finance"><HealthPage /></RequireSection>} />
        {/* The QuickBooks export moved to Flow → Finance ▸ QuickBooks (plan T8):
            one screen for every document type plus Sync issues. Old links and
            bookmarks (/finance/export/invoices, …/bills, …/history) forward there. */}
        <Route path="/finance/export/*" element={<MovedToFlow path="/finance/quickbooks" />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

/** The Ingestor was renamed Studio (CEO 2026-10-08); keep its query string. */
function IngestorRedirect() {
  const { search } = useLocation();
  return <Navigate to={`/studio${search}`} replace />;
}
